import { Box } from '@mui/material';
import 'typeface-montserrat';
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';
import { Heading, Title } from '../../components/shared/typography/PrimaryTypography';
import PrimaryButton from '../../components/shared/button/PrimaryButton';
import GhostButton from '../../components/shared/button/GhostButton';

/**
 * Shared Access Denied screen for when the current user doesn't have the permissions required for the current route.
 * @returns {JSX.Element}
 */
const AccessDenied = () => {
  const navigate: NavigateFunction = useNavigate();
  const current_url: string = useLocation().pathname;

  const handleNavigateContact = (): void => {
    navigate('/contact');
  };

  const handleNavigateHome = (): void => {
    navigate('/');
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8
        }}
      >
        <Title>Access Denied</Title>
        <Heading sx={{ mt: 4 }}>
          {`You don't have the required permissions to view ${current_url}.`}
        </Heading>
        <Box sx={{ display: 'flex', gap: 4 }}>
          <GhostButton outlined dark onClick={handleNavigateHome}>
            Back to Home
          </GhostButton>
          <PrimaryButton onClick={handleNavigateContact}>
            Contact an Energy Partners Admin
          </PrimaryButton>
        </Box>
      </Box>
    </>
  );
};

export default AccessDenied;
